import { connect } from "react-redux";
import { requestGetTriageDetailsByClaimId } from "../../../../store/data/thunks";
import { State } from "../../../../store/state";

import Triage from "./Triage";

const mapStateToProps = (state: State) => {
  return {
    triageDetails: state.data.triageDetails
  };
};

const mapDispatchToProps = {
    requestGetTriageDetailsByClaimId
};

const TriageContainer = connect(
  mapStateToProps,
  mapDispatchToProps
)(Triage);

export default TriageContainer;